import BaseProxy from './base-proxy';


/**
 * Class NotificationProxy
 */
class NotificationProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  getNotifications(payload, options = {}) {
    return this.submit('post', `${this.endpoint}/notifications/list`, payload, { showResponseStatus: true, ...options });
  }

  readNotification(payload, options = {}) {
    return this.submit('post', `${this.endpoint}/notifications/mark-read`, payload, { showResponseStatus: true, ...options });
  }
}

export default NotificationProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/notification-proxy.js